// extracted by mini-css-extract-plugin
export default {"service":"Service_service__buel5","main":"Service_main__DkHCI","items":"Service_items__L1hL9","item":"Service_item__03JEe"};